module.exports = __webpack_public_path__ + "static/media/Texto de sala Habitus1Edición.32a037cb.pdf";